<template>
    <div class="container" style="max-width: 987px !important;">
        <div class="whiteBgSec_1">
            <button class="closeBtn" @click="$emit('closed', '')"><i class="fa-solid fa-xmark"></i></button>
            <h2 class="text-center">My Account</h2>
            <form @submit.prevent="update_profile()">
            <div class="row py-5">
                <div class="col-md-6">
                    <label for="email">Name:</label>
                    <input placeholder="Full Name" type="text" class="form-control " v-model="form.name" v-validate="'required'" name="name" :class="{ 'is-invalid': verrors.has('name') }">
                    <p v-if="verrors.has('name')" class="errormsg">{{ verrors.first('name') }} </p>
                </div>
                <div class="col-md-6">
                    <label for="email">Email:</label>
                    <input id="email" type="text" class="form-control" v-model="form.email" disabled>
                </div>
                <div class="col-md-6">
                    <label for="email">Phone:</label>
                    <input placeholder="Phone Number" type="text" class="form-control " v-model="form.phone" v-validate="'required'" name="phone" :class="{ 'is-invalid': verrors.has('phone') }">
                    <p v-if="verrors.has('phone')" class="errormsg">{{ verrors.first('phone') }} </p>
                </div>
                <div class="col-md-6">
                    <label for="email">User Role:</label>
                    <input placeholder="User role" type="text" class="form-control " v-model="form.user_type" v-validate="'required'" name="user_type" :class="{ 'is-invalid': verrors.has('user_type') }" disabled> 
                </div>
            </div>


            

            <div class="accordion" id="accordionExample">
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Update Password
                </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                <div class="row py-5">
                    <div class="col-md-6">
                        <label for="npassword">Password:</label>
                        <input placeholder="Enter Password" type="password" class="form-control" v-model="form.npassword" v-validate="'min:8'" id="npassword" name="npassword" :class="{ 'is-invalid': verrors.has('npassword') }" data-vv-as="Password">
                        <p v-if="verrors.has('npassword')" class="errormsg">{{ verrors.first('npassword') }} </p>
                    </div>
                    <div class="col-md-6">
                        <label for="password">Confirm Password:</label>
                        <input placeholder="Repeat Password" type="password" class="form-control" v-model="form.cpassword" v-validate="form.npassword?'required|confirmed:npassword':''" name="cnf_password" :class="{ 'is-invalid': verrors.has('cnf_password') }" data-vv-as="Confirm Password">
                        <p v-if="verrors.has('cnf_password')" class="errormsg">{{ verrors.first('cnf_password') }} </p>
                    </div>
                </div>

                </div>
                </div>
            </div>

            </div>




            <div class="row mt-5 py-5">
                <div class="col-12 text-end">
                    <button class="gradientBtn_1 noStar" type="submit">Update</button>
                </div>
                <div class="col-12 text-end pt-5">
                    <button class="gradientBtn_1 noStar" type="button" @click="AILogout()">Logout</button>
                </div>
            </div>
        </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";  
export default {  
    name:'Account',
    data() {
        return {
            form:{
                id:'',
                name:'',
                email:'',
                phone:'',
                user_type:'',
                cpassword:'',
                npassword:''
            }
        };
    },
    watch: {
        Aiuser: {
             handler: function (newValue) {
                 if (newValue) {
                     if (this.Aiuser) { 
                             this.form.id=this.Aiuser.id
                             this.form.name=this.Aiuser.name
                             this.form.email=this.Aiuser.email
                             this.form.phone=this.Aiuser.phone
                             this.form.user_type=this.Aiuser.user_type
                     }else{
                        this.$router.push('/design-ai/login');
                     }
                 }
             },
             deep: true
         }
     },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Aiauth", ["Aiuser"]),
        ...mapGetters("Common", ["Setting"]),
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
    methods: {
        ...mapActions("Aiauth", ["getAIUserData","sendAILogoutRequest" ]),
        AILogout(){
        this.sendAILogoutRequest();
        this.$router.push('/design-ai/login');
        },
         
        async update_profile(){
            this.$validator.validateAll().then(async (valid) => {
                if (valid) { 
                    let loader = this.$loading.show({ loader: 'dots' })  
                    this.form.fAction="update_profile";
                    this.form.shop_id = this.showroomId.showroom 
                    axios.put('/api/AI/design/'+this.form.id, this.form)
                        .then(res => {
                            loader.hide()
                            if (res.data.data) {
                                 this.getAIUserData();
                                Toast.fire({
                                    icon: 'success',
                                    title: res.data.message
                                });
                            } else {
                                Toast.fire({
                                    icon: 'error',
                                    title: data.data.message
                                });
                            } 
                        })
                        .catch(err => {
                            loader.hide()
                        });

                }
            })
        }
    },
    

    mounted() { 
         
         if (this.Aiuser) {
            this.form.id=this.Aiuser.id
            this.form.name=this.Aiuser.name
            this.form.email=this.Aiuser.email
            this.form.phone=this.Aiuser.phone
            this.form.user_type=this.Aiuser.user_type
            
         }else{
            this.$router.push('/design-ai/login');
         }

     },

     
    
};

</script>
 